import { Component, Prop, Vue } from 'vue-property-decorator'
import Control from '@/helpers/control'
import fetch from '@/helpers/fetch'

@Component({
	components: {},
})
export default class TableHead extends Vue {
	@Prop() updateMap
	@Prop() fieldHumanNames

	async mounted() {
		this.$store.dispatch('fetchGroupsSimple')
		this.loadSubjectsOptions()
	}

	get groupsAllSimpleList() {
		return this.$store.state.clients.groupsAllSimpleList
	}

	filteredClient: any = null
	filteredCnj = ''
	filteredDistributionDateFrom: any = null
	filteredDistributionDateTo: any = null
	filteredDecisionDateFrom: any = null
	filteredDecisionDateTo: any = null
	filteredDecisionDate: any = null
	filteredSubject: any = null
	filteredDecisionStatus: any = null
	filteredUsageStatus: any = null
	filteredVisibleToClient: any = null
	filteredClosed: any = null
	getFilters() {
		const filters: any = {}

		if (this.filteredClient) {
			filters.group = this.filteredClient?.id
		}

		if (this.filteredDistributionDateFrom) {
			const originalDate = this.filteredDistributionDateFrom
			const date = originalDate.split('/').reverse().join('-')
			filters.distributionDateFrom = date
		}

		if (this.filteredDistributionDateTo) {
			const date = this.filteredDistributionDateTo
				.split('/')
				.reverse()
				.join('-')
			filters.distributionDateTo = date
		}

		if (this.filteredDecisionDateFrom) {
			const originalDate = this.filteredDecisionDateFrom
			const date = originalDate.split('/').reverse().join('-')
			filters.decisionDateFrom = date
		}

		if (this.filteredDecisionDateTo) {
			const date = this.filteredDecisionDateTo
				.split('/')
				.reverse()
				.join('-')
			filters.decisionDateTo = date
		}

		if (this.filteredCnj) {
			const cnj = this.filteredCnj?.replace(/-/g, '')?.replace(/\./g, '')
			filters.cnj = cnj
		}

		if (this.filteredSubject) {
			filters.subject = this.filteredSubject.id
		}

		if (this.filteredDecisionStatus) {
			filters.decisionStatus = this.filteredDecisionStatus
		}

		if (this.filteredUsageStatus) {
			filters.usageStatus = this.filteredUsageStatus
		}

		if (
			this.filteredVisibleToClient === true ||
			this.filteredVisibleToClient === false
		) {
			filters.visibleToClient = this.filteredVisibleToClient
		}

		if (this.filteredClosed === true || this.filteredClosed === false) {
			filters.closed = this.filteredClosed
		}

		return filters
	}

	control = new Control()

	async onFilterInput() {
		this.$emit('request', this.getFilters(), 1)
	}

	async onFilterCnjInput() {
		const debouncedChange = this.control.debounce(this.onFilterInput, 1000)
		debouncedChange()
	}

	async onFilterDateInput(type, value) {
		if (value === '' || (value && value.length === 10)) {
			this.onFilterInput()
		}
	}

	async onFilterDecisionStatusInput() {
		this.onFilterInput()
	}

	async onFilterClosedInput() {
		this.onFilterInput()
	}

	onFilterVisibleToClientInput() {
		this.onFilterInput()
	}

	subjectsOptions: any = []
	async loadSubjectsOptions() {
		const res = await fetch.get('/api/subjects')
		if (res.ok) {
			if (res.data && res.data.length) {
				const filteredSubjects = res.data.filter(
					(s) => s?.name !== '[EM BRANCO]',
				)

				this.subjectsOptions.push(...filteredSubjects)
			}
		}
	}

	onSearch(allItems, search) {
		if (typeof search !== 'string') return
		const searchArray = search?.split(' ')

		const result = allItems.filter((item) => {
			const name = removeAccents(item.name.toLowerCase())

			return searchArray.every((string) => {
				return name.includes(removeAccents(string.toLowerCase()))
			})
		})

		return result
	}

	getModifies(name) {
		return (
			'Modifica: ' +
			this.updateMap?.[name]?.modifies
				.map((name) => {
					return '"' + this.fieldHumanNames[name] + '"'
				})
				.join(', ')
		)
	}
}

function removeAccents(str) {
	return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}
